import { default as index6is6zxqNfFMeta } from "/tmp/my-website-master/pages/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/tmp/my-website-master/pages/index.vue").then(m => m.default || m)
  }
]